var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"secondary","small":""},on:{"click":_vm.openLegendSheet}},[_vm._v("画面表示の説明")])}
var staticRenderFns = []

export { render, staticRenderFns }